// extracted by mini-css-extract-plugin
export default {"wrapper":"KanbanTableW_wrapper__b2+Jd","item__wrapper":"KanbanTableW_item__wrapper__ferdI"};